export const GET_ANALOGS_LIST = 'GET_ANALOGS_LIST';
export const CREATE_SUGGESTION = 'CREATE_SUGGESTION';
export const SAVE_SUGGESTIONS_ORDER = 'SAVE_SUGGESTIONS_ORDER';
export const DELETE_SUGGESTION = 'DELETE_SUGGESTION';
export const GET_ANALOGS_LIST_PHARMACIST = 'GET_ANALOGS_LIST_PHARMACIST';
export const GET_ANALOGS_INFORMATION_LIST_PHARMACIST =
  'GET_ANALOGS_INFORMATION_LIST_PHARMACIST';
